// extracted by mini-css-extract-plugin
export default {"AlertModalsBorder":"VLjfV","AlertModalsTextWidth":"hfqNN"};